// Number behavior for grid columns.
//
// Formats numeric values with locale-appropriate grouping (e.g. 1,234)
// and strips non-numeric characters on input.
//
// Column def:  { field: "mileage", behavior: "number" }

import { createBehavior } from "./create_behavior"

export const number = createBehavior({
  valueFormatter({ value }) {
    if (value == null || value === "") return ""
    const num = parseFloat(value)
    if (isNaN(num)) return value
    return num.toLocaleString("en-US")
  },
  valueSetter({ newValue, data, colDef }) {
    const cleaned = String(newValue ?? "").replace(/[^0-9.\-]/g, "")
    const num = parseFloat(cleaned)
    data[colDef.field] = isNaN(num) ? null : num
    return true
  }
})
